import React from 'react';
import { useEffect, useState } from 'react';
import Footer from '../Components/Footer';
import '../Styles/GroupReservation.scss';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import '../Styles/WeekSelection.scss';
import Disclaimer from '../Components/Disclaimer';
import DateHelpers from '../Helper/DateHelpers'
import CamperTypeSelection from '../Components/CamperTypeSelection';
import '../Styles/CardsforCamperType.scss';
import '../Styles/JoinGroup.scss';
import CampEventAndDateSelection from '../Components/CampEventAndDateSelection';
import GroupReservationTypeSelection from '../Components/GroupReservationTypeSelection';
import ReservationSpotSelection from '../Components/ReservationSpotSelection';
import { Helmet } from "react-helmet";
import { parseISO } from "date-fns";
import Session from 'react-session-api';
import { CombinationPageOptions } from '../Constants/RegistrationPageOptions';
import DataAccessHelper from '../Helper/DataAccessHelper';
function JoinGroup({ groupJoined, setGroupJoined, week, selectedPage, setSelectedPage, reservationInfo, setReservationInfo, setPromoCode, setIsInGroup}) {

   const [groupCode, setGroupCode] = useState('');
   const [groupSearchResponse, setGroupSearchResponse] = useState('No Search Yet')
   const [noSlotsFromEventError, setNoSlotsFromEventError] = useState(false)
   const [noSlotsFromFastTrackError, setNoSlotsFromFastTrackError] = useState(false)
   const navigate = useNavigate();
   setPromoCode(false)

   async function groupSearch() {
      try {
         console.log("Group Code", groupCode)
         var registType = 'Group'
         var eventId = week.event_id;
         console.log("Event Id", eventId)
         var groupRequest = await fetch('/searchgroup', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               groupCode,
               eventId
            })
         })
         let groupResponse = await groupRequest.json();
         console.log("group Response", groupResponse)
         let response = groupResponse.data.searchGroupQuery.rows[0];
         if (response == '') {
            setGroupSearchResponse('');
            setIsInGroup(false)
         }
         else {
            setGroupSearchResponse(response);
            setIsInGroup(true)
         }

      } catch (error) {
         console.log(error)
      }
   }

   async function handleGroupSelection() {
      try {


         // Add the Group Selection
         setGroupJoined(groupSearchResponse)
         let numberOfSlots = 0;
         const reservationId = groupSearchResponse.reservation_id


         // Search selected group for fast track reservation
         console.log("Group Search Response", groupSearchResponse)
         if (groupSearchResponse.is_fast_track == true) {
            console.log("Group has fast track")
            const fastTrackResponse = await DataAccessHelper.getFastTrackInformation(reservationId)
            numberOfSlots = fastTrackResponse.data.eventInfo[0].slots_reserved
            setReservationInfo(fastTrackResponse.data.eventInfo[0])
         }
         // No fast track, check only main event slots
         else {
            console.log("Group does not have fast track")
            const standardReservationResponse = await DataAccessHelper.getStandardReservationInformation(reservationId)
            console.log("Standard Reservation Response in the no fast track", standardReservationResponse)
            numberOfSlots = standardReservationResponse.data.eventInfo[0].slots_reserved
            setReservationInfo(standardReservationResponse.data.eventInfo[0])
         }

         if (numberOfSlots < 1 && week.number_of_slots < 1) {
            console.log("Not Enough reservation slots")
            setNoSlotsFromEventError(true)
         }
         else {
            // Enough slots for registration, continue
            setSelectedPage(CombinationPageOptions.CamperType)
         }

      } catch (error) {
         console.log(error)
      }
   }

   function handleIndividualSelection() {
      // Set the group joined to null
      setGroupJoined(null)

      // Check event's number of slots
      if (week.number_of_slots < 1) {
         setNoSlotsFromEventError(true)
      }
      else {
         setSelectedPage(CombinationPageOptions.CamperType)
      }
   }

   return (
         <div className="JoinGroupContent">
            <div className="JoinGroupHeading">
               Join A Group
            </div>
            <div className="JoinGroupExplanation">
               Enter a valid group code to join a group.
            </div>
            <div className="JoinGroupInsertion">
               <form>
                  <div className='groupCodeInputBar'>
                     <div>
                        <input
                           id='joinGroupCode'
                           type='text'
                           maxlength={8}
                           value={groupCode}
                           onChange={(event) => setGroupCode(event.target.value)}
                        />
                     </div>
                  </div>
               </form>
               {groupSearchResponse == null &&
                  <div className="JoinGroupNotFoundResponse">
                     Group not found, please enter a valid group code to join a group.
                  </div>
               }
               {(groupSearchResponse != null && groupSearchResponse != 'No Search Yet') &&
                  <div className="JoinGroupFoundResponse">
                     <div className="JoinGroupFoundResponseName">
                        Group Found: {groupSearchResponse.group_name}, {groupSearchResponse.group_city} {groupSearchResponse.group_state}
                     </div>
                     <div className="JoinGroupFoundResponseSelectButton">
                        <button onClick={event => handleGroupSelection()}>
                           Join
                        </button>
                     </div>

                  </div>
               }
               {noSlotsFromEventError == true &&
                  <div className="JoinGroupNoSlotsFromEventError">
                     This event is full
                     <button onClick={event => navigate('/individualaccount')}>
                        Exit
                     </button>
                  </div>
               }
            </div>
            <div className="JoinGroupSearch">
               <button onClick={event => { groupSearch() }}>
                  Search
               </button>
            </div>
            <hr>
            </hr>
             <div className="JoinGroupDecisionSection">
               OR
            </div>
            <div className="JoinGroupSkip">
               <button onClick={() => handleIndividualSelection()}>
                  Register as Individual
               </button>
            </div>
         </div>
   )
}
export default JoinGroup
